import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, Dialog, IconButton, Switch, Typography } from "@mui/material";
import { masterAPI } from "../dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { useSelector } from "react-redux";
import {
  EditOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";

import WorkFlowModal from "./WorkFlowModal";

const WorkFlow = () => {
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    getData();
    getRoles();
  }, []);

  const getRoles = async () => {
    const link = masterAPI["selectList"].getRoles;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        const rolesData = Array.isArray(res.data) ? res.data : (res.data.result || []);
        setRoles(rolesData);
      })
      .catch((e) => {
        setRoles([]);
      });
  };

  const getData = async () => {
    setIsLoading(true);
    const workflowLink = masterAPI["workFlow"].link;
    await axiosPrivate
      .get(`${workflowLink}`)
      .then((res) => {
        if (filterValue === "enableData") {
          const filterDataResult = res.data.result.filter((fil) => fil.isActive);
          setData(filterDataResult);
          setBackUpData(res.data.result);
        } else {
          setData(res.data.result);
          setBackUpData(res.data.result);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        setData([]);
        setBackUpData([]);
      });
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };

  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  const handleDelete = async (e, id) => {
    const enableLink = masterAPI["workFlow"].enable;
    const disableLink = masterAPI["workFlow"].disable;
    if (e.target.checked) {
      await axiosPrivate
        .put(`${enableLink}/${id}`)
        .then((res) => {
          getData();
        })
        .catch((e) => {
        });
    } else {
      await axiosPrivate
        .put(`${disableLink}/${id}`)
        .then((res) => {
          getData();
        })
        .catch((e) => {
        });
    }
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: () => {
        return (
          <Box sx={{ width: color.checkBoxWidth }}>
            <Checkbox />
          </Box>
        );
      },
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "WorkFlow Type",
      accessor: "workflowFor",
    },
    {
      Header: "Work Flow Level",
      accessor: "workFlowLevel",
    },
    {
      Header: "Role",
      accessor: "roleId",
      Cell: ({ cell }) => {
        const roleId = cell.row.original.roleId;
        const role = roles.find((r) => r.value === roleId);
        return role ? role.text : roleId;
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton disabled={!actionsAllow.edit}>
              <EditOutlined
                onClick={() => {
                  handleEdit(cell.row.original);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.edit
                    ? color.masterEditDelButtonColor
                    : "default",
                }}
              />
            </IconButton>

            <Switch
              disabled={!actionsAllow.delete}
              checked={cell.row.original.isActive}
              onChange={(e) => {
                handleDelete(e, cell.row.original.id);
              }}
            />
          </Box>
        );
      },
    },
  ];

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);
      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI["workFlow"].title}
        </Typography>
      </Box>

      <TableContainer
        columns={columns}
        data={data}
        buttonNew={handleButtonNew}
        loading={isLoading}
        buttonDisable={!actionsAllow.create}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
      />

      <Dialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"md"}
        children={
          <WorkFlowModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
    </>
  );
};

export default WorkFlow;

